import React, {Fragment, useContext, useEffect, useMemo, useState} from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../helpers/Colors';
import Text from '../Text';
import assets from '../../../helpers/assets';

function Steps({ type, statusHistory, order }) {
    const classes = useStyles();

    const [stepList, setStepList] = useState([]);

    const STEP_NAMES = {
        'ACCEPTED': 'Order Accepted',
        'READY_TO_DISPATCH': 'Ready To Dispatch',
        'DRIVER_CHECKED_IN': 'Driver Arrived',
        'DRIVER_CHECKED_OUT': 'Driver Left',
        'DRIVER_ASSIGNED': 'Driver Assigned',
        'DISPATCHED': 'Dispatched',
        'COMPLETED': 'Completed'
    };

    useEffect(() => {
        if (!statusHistory) return;
        if (type === 'pickup') {
            setStepList(sortSteplist(statusHistory.filter((item) => {
                return item.status === 'ACCEPTED'
                    || item.status === 'READY_TO_DISPATCH'
                    || item.status === 'DRIVER_CHECKED_IN'
                    || item.status === 'DRIVER_CHECKED_OUT'
                    || item.status === 'DRIVER_ASSIGNED';
            })));
        } else {
            setStepList(sortSteplist(statusHistory.filter((item) => {
                return item.status === 'ACCEPTED'
                    || item.status === 'READY_TO_DISPATCH'
                    || item.status === 'DRIVER_CHECKED_IN'
                    || item.status === 'DRIVER_CHECKED_OUT'
                    || item.status === 'DISPATCHED'
                    || item.status === 'COMPLETED'
                    || item.status === 'DRIVER_ASSIGNED';
            })));
        }
    }, [statusHistory]);

    const sortSteplist = (steps) => {
        const sorted = steps.sort((a, b) => {
            if (a === 'COMPLETED' && b === 'DISPATCHED') {
                return 1;
            }
            return 0;
        });
        return sorted;
    }

    const getLastIndex = () => {
        if (type === 'pickup') {
            return 4;
        } else {
            return 6;
        }
    }

    const getTimeText = (index) => {
        let timeText = '';

        if (stepList[index]) {
            const time = new Date(parseFloat(stepList[index].eventCompletedTime));
            let hour = time.getHours();
            let minute = time.getMinutes();

            if (hour.toString().length === 1) hour = `0${hour}`;
            if (minute.toString().length === 1) minute = `0${minute}`;
            timeText = `${hour}:${minute}`;
        }
        return timeText;
    }

    const getIcon = (status) => {
        if (status === 'COMPLETED') {
            return assets.star.default;
        }
        return assets.tick.default;
    };

    const shouldRenderLine = (index) => {
        if (type === 'pickup') {
            return index < getLastIndex();
        } else {
            return index < stepList.length - 1;
        }
    };

    return useMemo(() => {
        return (
            <Fragment>
                <Box style={{display:'flex', flexDirection: 'column', flex: 1}}>
                    <Box className={classes.statusStepsContainer}>
                        {[...Array(getLastIndex() + 1)].map((i, index) => {

                            const completed = index < stepList.length;

                            return (
                                // className={index < 3 ? classes.statusStepItemContainer : classes.statusStepLastItemContainer}
                                <Box key={index} className={index <= getLastIndex() ? classes.statusStepItemContainer : classes.statusStepLastItemContainer}>

                                    { (index < stepList.length || type === 'pickup') &&  <Box className={classes.stepIconsContainer}>
                                        <Box className={completed ? classes.stepCompletedIconsView : classes.stepIconsView}>
                                            {completed && (
                                                <img
                                                    src={getIcon(stepList[index].status)}
                                                    alt=""
                                                    className={classes.tickIcon}
                                                />
                                            )}
                                        </Box>
                                        {shouldRenderLine(index) && (
                                            <Box className={classes.stepIconBackground}></Box>
                                        )}
                                    </Box>
                                    }
                                    <Text className={classes.statusLabel}>{getTimeText(index)} {stepList[index] ? STEP_NAMES[stepList[index].status] : ''}</Text>
                                </Box>
                            )

                        })}
                    </Box>

                </Box>
            </Fragment>
        )
    }, [stepList.length]);
}

const useStyles = makeStyles((theme) => ({
    statusLabel: {
        fontSize: 14,
        color: Colors.textColor,
        fontFamily: 'DINNextLTPro-Regular',
    },
    tickIcon: {
        height: 10,
        width: 10,
        objectFit: 'contain',
    },
    statusStepsContainer: {
        display: 'flex',
        flex: 0.9,
        flexDirection: 'row',
        // alignItems: 'center',
        height: '100%',
    },
    statusStepItemContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        // justifyContent: 'center',
        marginTop: '5px',
    },
    statusStepLastItemContainer: {
        height: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    stepIconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    stepIconsView: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.white,
        height: 20,
        width: 20,
        borderRadius: 20,
        border: `1px solid ${Colors.blue}`,
    },
    stepCompletedIconsView: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.blue,
        height: 20,
        width: 20,
        borderRadius: 20,
        border: `1px solid ${Colors.blue}`,
    },
    stepIconBackground: {
        height: 4,
        flex: 1,
        backgroundColor: Colors.fadedBlue,
    },
    buttonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: Colors.boldBlue,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    disabledButtonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: 'rgba(25, 136, 252, 0.3)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    warningIcon: {
        height: 10,
        width: 10,
        objectFit: 'contain',
    },
    timerContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    timerWarningIconContainer: {
        height: 18,
        width: 18,
        borderRadius: 20,
        marginLeft: 6,
        backgroundColor: Colors.red,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    list: {
        height: '100%',
        overflow: 'auto',
        width: '100%',
        borderRadius: 4,
    },
}));

export default Steps;